import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import React, { useEffect, useRef } from "react";
import FormTextField from "../../components/formFields/FormTextField";
import { requiredValidator } from "../../components/formFields/CommonValidator";
import { Button } from "@progress/kendo-react-buttons";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  createFlightPlace,
  getAllFlightPlaces,
  updateFlightPlace,
  getFlightPlaceById,
  findAllActiveFlightPlace,
} from "./services/flightPlace.services";
import { clearFlightPlaceDetails } from "./flightPlaceSlice";
import { closed } from "../../components/drawer/drawerSlice";
import { LoadingPanel } from "../../components/layout/Loading";
import { Typography } from "@progress/kendo-react-common";
import { RxCross1 } from "react-icons/rx";
import FormSelectionField from "../../components/formFields/FormSelectionField";
import FormCheckbox from "../../components/formFields/FormCheckbox";
import { STATUSARRAY } from "../../_contstants/common";

const CreateFlightPlace: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);

  const FlightPlaceDetail = useAppSelector(
    (state) => state.flightPlace.FlightPlaceDetail
  );
  const ID = useAppSelector((state) => state.drawer.data);
  const isIndirect = useAppSelector((state) => state.drawer.isIndirect);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FlightPlaceFilter: any = useAppSelector(
    (state) => state.flightPlace.FlightPlaceFilter
  );

  const formLoading = useAppSelector((state) => state.flightPlace.formLoading);

  useEffect(() => {
    return () => {
      dispatch(clearFlightPlaceDetails());
      dispatch(closed());
    };
  }, []);

  useEffect(() => {
    if (ID) {
      dispatch(getFlightPlaceById(ID));
    }
  }, [ID]);

  const handleSubmit = async (values: any) => {
    try {
      if (!ID) {
        const payload = {
          Type: "",
          PopCity: false,
          Airport: values.Airport,
          Value: values.Value,
          Name: values.Name,
          CurrencyCode: values.CurrencyCode,
          CountryCode: values.CountryCode,
          IsFavorite: values.IsFavorite,
          IsActive: values.IsActive === 1,
        };

        const response = await dispatch(createFlightPlace(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearFlightPlaceDetails());
          if (isIndirect) {
            dispatch(findAllActiveFlightPlace());
          } else {
            const payload = {
              ...FlightPlaceFilter,
              Limit: +pageLimit,
              Skip: +currentPage * +pageLimit,
            };

            dispatch(getAllFlightPlaces(payload));
          }
        }
      } else {
        const payload = {
          Type: "",
          PopCity: false,
          ID: ID,
          Airport: values.Airport,
          Value: values.Value,
          Name: values.Name,
          CurrencyCode: values.CurrencyCode,
          CountryCode: values.CountryCode,
          IsFavorite: values.IsFavorite,
          IsActive: values.IsActive === 1,
        };
        const response = await dispatch(updateFlightPlace(payload));
        if (response?.meta?.requestStatus === "fulfilled") {
          dispatch(closed());
          dispatch(clearFlightPlaceDetails());
          const payload = {
            ...FlightPlaceFilter,
            Limit: +pageLimit,
            Skip: +currentPage * +pageLimit,
          };

          dispatch(getAllFlightPlaces(payload));
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      throw error;
    }
  };

  const handleFormClose = () => {
    dispatch(closed());
  };

  if (formLoading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={FlightPlaceDetail}
      render={(formRenderProps: FormRenderProps) => (
        <FormElement style={{ width: "100%" }}>
          <GridLayout
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
            gap={{ rows: 10 }}
            cols={[{ width: "100%" }]}
          >
            <GridLayoutItem
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                margin: "17px 0 8px",
              }}
            >
              <Typography.h4 className="m-0">
                {ID ? "Update Flight Place" : "Create Flight Place"}
              </Typography.h4>
              <Button
                type="button"
                fillMode={"flat"}
                themeColor={"dark"}
                style={{ marginRight: 4 }}
                onClick={() => dispatch(closed())}
              >
                <RxCross1 />
              </Button>
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="Airport"
                label="Flight Place Name"
                component={FormTextField}
                placeholder="Flight Place Name"
                astrike={true}
                validator={requiredValidator}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="Value"
                label="Flight Place Code"
                component={FormTextField}
                placeholder="Flight Place Code"
                astrike={true}
                validator={requiredValidator}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="Name"
                label="City Name"
                component={FormTextField}
                placeholder="City Name"
                astrike={true}
                validator={requiredValidator}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="CountryCode"
                label="Country Code"
                component={FormTextField}
                placeholder="IN"
                astrike={true}
                validator={requiredValidator}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="CurrencyCode"
                label="Currency Code"
                component={FormTextField}
                placeholder="INR"
                astrike={true}
                validator={requiredValidator}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                id={"IsActive"}
                name={"IsActive"}
                component={FormSelectionField}
                label={"Status"}
                options={STATUSARRAY?.map((status: any) => {
                  return {
                    value: status.value,
                    label: status.label,
                  };
                })}
              />
            </GridLayoutItem>
            <GridLayoutItem style={{ width: "100%" }}>
              <Field
                name="IsFavorite"
                label="Favourite"
                component={FormCheckbox}
                placeholder="Favourite"
              />
            </GridLayoutItem>
            <GridLayoutItem
              colSpan={3}
              style={{
                textAlign: "end",
                marginTop: "10px",
                width: "100%",
              }}
            >
              <Button
                type="button"
                fillMode={"outline"}
                themeColor={"primary"}
                style={{ marginRight: 4 }}
                onClick={handleFormClose}
              >
                Cancel
              </Button>
              <ButtonWithLoading
                label={ID ? "Update" : "Create"}
                type="submit"
                disabled={!formRenderProps.allowSubmit || formLoading}
                loading={formLoading}
              />
            </GridLayoutItem>
          </GridLayout>
        </FormElement>
      )}
    />
  );
};

export default CreateFlightPlace;
